<div nz-row>
  <div nz-col nzSpan="24" style="margin-bottom: 1rem;" class="no-form">
    <h1>{{ title }}</h1>
  </div>
</div>
<nz-spin [nzSpinning]="isSpinning$ | async" nzSize="large" class="full-width">
  <div class="centered-box-vertical extralarge">
    <div nz-row nzJustify="end" class="withMargin">
      <div nz-col  [nzSpan]="9">
        <app-search></app-search>
      </div>
    </div>
    <div class="full-width">
      <nz-table #requestsData [nzData]="requests | async"
        [nzFrontPagination]="false" [nzTotal]="total" [nzPageSize]="this.searchService.pageSize" [nzPageIndex]="this.searchService.pageIndex"
        (nzQueryParams)="onQueryParamsChange($event)" nzTableLayout="fixed"
      >
        <thead>
          <tr>
            <th nzColumnKey="id" [nzSortFn]="true" [nzLeft]="true" [nzRight]="false">
              <span> Id richiesta </span>
            </th>
            <th class="middle-cell" nzColumnKey="fiscalCode" [nzSortFn]="true" [nzLeft]="false" [nzRight]="false">
              <span> Codice fiscale </span>
            </th>
            <th class="middle-cell" nzColumnKey="email" [nzSortFn]="true" [nzLeft]="false" [nzRight]="true">
              <span> Email </span>
            </th>
            <th class="middle-cell" nzColumnKey="status" [nzSortFn]="true" [nzFilters]="filterStatus"  [nzFilterMultiple]="false" [nzFilterFn]="true" [nzLeft]="true" [nzRight]="true">
              <span> Status </span>
            </th>
            <th class="end-cell" nzColumnKey="actions">
              <span class="with-margin"> Azioni </span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let request of requestsData.data">
            <td><p class="requests">{{ request.id }}</p></td>
            <td><p class="requests">{{ request.fiscalCode }}</p></td>
            <td><p class="requests">{{ request.email }}</p></td>
            <td><p class="requests">{{ request.status }}</p></td>
            <td class="actions">
              <span class="cell-content actions requests" *ngIf="canDoAction(request)">
                <button nz-button nz-dropdown [nzDropdownMenu]="requestActions" nzPlacement="bottomRight" nzTrigger="click">
                  <i nz-icon nzType="more" nzTheme="outline"></i>
                </button>
                <nz-dropdown-menu #requestActions="nzDropdownMenu">
                  <ul class="actions-list" nz-menu>
                    <li *ngIf="canBeApproved(request)"
                      i18n="Request.RequestList.CompleteRequest|modify documents@@Request.RequestList.CompleteRequest"
                      nz-menu-item (click)="completeRequest(request)">
                      <i nz-icon [nzType]="'edit'" [nzTheme]="'twotone'" [nzTwotoneColor]="'gray'"></i>
                      Completa
                    </li>
                    <li *ngIf="canBeCancelled(request)"
                      i18n="Request.RequestList.Cancel|cancel request@@Request.RequestList.Cancel"
                      nz-menu-item (click)="cancelRequest(request.id)">
                      <i nz-icon [nzType]="'delete'" [nzTheme]="'twotone'" [nzTwotoneColor]="'red'"></i>
                      Cancella
                    </li>
                  </ul>
                </nz-dropdown-menu>
              </span>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </div>
  </div>
</nz-spin>
